@import 'src/global/media_queries'
  
:host
  display: block 

.gamble-policy-wrapper,
.gamble-policy-wrapper * 
  box-sizing: border-box
  line-height: 1rem


.gamble-policy-wrapper 
  width: 100%
  display: grid
  grid-template-areas: "chances chances chances chances license license license license" "help help help warning warning warning age age" "website website website warning warning warning age age"

  --fs-top: 10pt
  --fs-help: 9pt
  --fs-website: 9pt
  --fs-warning: 14pt
  --fs-age: 12pt

  --p-y: 0.3rem
  --p-x: 0.6rem


.gamble-policy-wrapper span 
  display: block
  font-family: Arial, Helvetica, sans-serif
  font-weight: 400


.gamble-policy-wrapper a 
  text-decoration: none
  color: #FFF
  font-family: Arial, Helvetica, sans-serif


.gamble-policy-wrapper>* 
  padding: var(--p-y) var(--p-x)
  display: flex
  flex-direction: column
  justify-content: center


.gp__top 
  font-size: var(--fs-top)
  color: #000
  border-top: 1px solid #000
  border-bottom: 1px solid #000
  background-color: #FFF


.gp__bottom 
  color: #FFF
  background-color: #000


.gp__bottom span 
  font-weight: 700


.chances-wrapper 
  grid-area: chances
  border-left: 1px solid #000


.license-wrapper 
  grid-area: license
  text-align: right
  border-right: 1px solid #000


.help-wrapper 
  grid-area: help
  padding-bottom: 0
  font-size: var(--fs-help)
  text-align: left !important


.website-wrapper 
  grid-area: website
  font-size: var(--fs-website)
  padding-top: 0
  text-align: left !important


.warning-wrapper 
  grid-area: warning
  font-size: var(--fs-warning)
  font-style: italic


.age-wrapper 
  grid-area: age
  font-size: var(--fs-age)


@media screen and (max-width: 690px) 
  .gamble-policy-wrapper 
    grid-template-areas: "chances chances" "license license" "warning warning" "help age" "website age"
  

  .gp__top,
  .gp__bottom 
    text-align: center
  

  .gp__top 
    border-left: 1px solid #000
    border-right: 1px solid #000
  

  .chances-wrapper 
    border-bottom: 0
    padding-bottom: 0
  

  .license-wrapper 
    border-top: 0
    padding-top: 0
  


@include media("<=390px") 
  .gamble-policy-wrapper 
    grid-template-areas: "chances chances" "license license" "warning warning" "help help" "website age"
  

  .age-wrapper,
  .website-wrapper 
    text-align: left
    padding-top: var(--p-y)
  


@include media(">=tablet")
  .gamble-policy-wrapper 
    grid-template-areas: "chances chances chances license license license" "help help warning warning age age" "website website warning warning age age"
  

  .warning-wrapper 
    text-align: center
  

  .age-wrapper 
    text-align: center
  

